module.exports = __webpack_public_path__ + "static/media/Logo Video 2.2008ba77.mp4";